import { KeyboardEvent, useEffect, useState } from "react"
import { filtrosBA } from "../../models/Obras.model";
import Select from 'react-select';
import AreaResultados from "../Busqueda/main";
import { webApiInputAutores, webApiInputColecciones, webApiInputAnios,webApiInputTemas } from "../../routes/endpoints";
import axios from "axios";
import { Option } from "chakra-ui-simple-autocomplete";
import { ventana } from "../../utilities/Alertas";

export default function Main() {
    localStorage.setItem("seccion", '')
    const tit = (localStorage.getItem("tituloBA") !== null)? localStorage.getItem("tituloBA")!:"";
    const autorBA = (localStorage.getItem("autBA") !== null)? localStorage.getItem("autBA")!:"";
    console.log(localStorage.getItem('autBA'));
    
    const tem = (localStorage.getItem("temaBA") !== null)? localStorage.getItem("temaBA")!:"";
    const isb = (localStorage.getItem("ISBNBA") !== null)? localStorage.getItem("ISBNBA")!:"";
    const pala = (localStorage.getItem("palabraClaveBA") !== null)? localStorage.getItem("palabraClaveBA")!:"";
    const busDoc = (localStorage.getItem("documentoBA") !== null)? localStorage.getItem("documentoBA")!:"";
    const anioPublicacionBA = (localStorage.getItem("anios_values") !== null)? localStorage.getItem("anios_values")!:"";
    const coleccionBA = (localStorage.getItem("colecciones_values") !== null)? localStorage.getItem("colecciones_values")!:"";
    
    const [selectedAutor, setSelectedAutor] = useState<Option[]>(); 
    const [selectedColeccion, setSelectedColeccion] = useState<Option[]>(); 
    const [selectedTema, setSelectedTema] = useState<Option[]>(); 
    const [selectedAnio, setSelectedAnio] = useState<Option[]>(); 


    const [tituloBA, setTituloBA] = useState(tit)
    const [temaBA, setTemaBA] = useState(tem)  
    const [ISBNBA, setISBNBA] = useState(isb) 
    const [palabraClaveBA, setPalabraClaveBA] = useState(pala);
    const [documentoBA, setDocumentoBA] = useState(busDoc); 
    
    const [inputAutores, setInputAutores] =  useState<Option[]>([]);
    const [inputColecciones, setInputColecciones] =  useState<Option[]>([]);
    const [inputTemas, setInputTemas] =  useState<Option[]>([]);
    const [inputAnios, setInputAnios] =  useState<Option[]>([]);

    const requestAutores = axios.get(webApiInputAutores)
    const requestColeciones = axios.get(webApiInputColecciones)
    const requestTemas= axios.get(webApiInputTemas)
    const requestAnios = axios.get(webApiInputAnios)
    useEffect(()=>{     
        localStorage.clear();
        console.log('entro');
        
        axios.all([requestColeciones, requestAnios,requestTemas,requestAutores]).then(axios.spread((...responses) => {            
            setInputColecciones(responses[0].data)
            setInputAnios(responses[1].data)
            setInputTemas(responses[2].data)
            setInputAutores(responses[3].data)            
        })).catch(errors =>  console.warn(errors) )
    },[]);

    const [filtros, setFiltros] = useState<filtrosBA>({tituloBA,autorBA,palabraClaveBA,ISBNBA,coleccionBA, temaBA, anioPublicacionBA, documentoBA}) 
    const autoresSelect = (localStorage.getItem("autBA") !== null)? JSON.parse(localStorage.getItem("autBA")!):[]; 
    const ani = (localStorage.getItem("aniosBA") !== null)? JSON.parse(localStorage.getItem("aniosBA")!):[];
    const col = (localStorage.getItem("colBA") !== null)? JSON.parse(localStorage.getItem("colBA")!):[];
    const temaselect = (localStorage.getItem("temaSeleccionado") !== null)? JSON.parse(localStorage.getItem("temaSeleccionado")!):{};
    const [resultC, setResultC] = useState<Option[]>(col);
    const [resultAut, setResultAut] = useState<Option[]>(autoresSelect);    
    
    const [autorSeleccionado, setAutorSeleccionado] = useState<Option[]>(autoresSelect);    
    const [coleccionSeleccionada, setColeccionesSeleccionadas] = useState<Option[]>(col);
    const [temaSeleccionado, setTemaseleccionado] = useState<Option[]>(temaselect);
    
    const [anioSeleccionada, setAnioSeleccionada] = useState<Option[]>(ani);
   
    useEffect(()=>{},[filtros])

    const Filtros = (e: KeyboardEvent<HTMLInputElement>, tipo:number) =>{ 
        switch (tipo) {
            case 0:
               setTituloBA(e.currentTarget.value)
            break;
            case 2:
                setTemaBA(e.currentTarget.value)
            break; 
            case 3:
                setISBNBA(e.currentTarget.value)
            break; 
            case 4:
                setPalabraClaveBA(e.currentTarget.value)
            break; 
            case 5:
                setDocumentoBA(e.currentTarget.value)                                              
            break; 
        }                        
    }
    const generaFiltros = ()=>{
        let colecc = '';
        let anios = '';
        let autor = '';
        let vacio = true

        resultAut.map( (res, i) => {            
            autor =  `${autor},${(res.value)}`
        })        
        resultC.map( (res, i) => {
            colecc =  `${colecc},${(res.value)}`
        })
        anioSeleccionada.map( (res, i) => {
            anios =  `${anios},${(res.value)}`
        })  
        const campos = [tituloBA,autor,palabraClaveBA,ISBNBA,colecc,temaBA,anios, documentoBA]         
        for(const campo of campos){
          if(campo.length>0) vacio = false
        } 
        if(vacio){
            ventana('', 'Debe especificar un criterio para realizar la búsqueda de información', 'info')
        }else{                        
            localStorage.setItem("tituloBA", tituloBA)
            localStorage.setItem("autores_values", autor)
            localStorage.setItem("temaBA", temaBA)   
            localStorage.setItem("ISBNBA", ISBNBA)   
            localStorage.setItem("palabraClaveBA", palabraClaveBA)   
            localStorage.setItem("documentoBA", documentoBA)    
            localStorage.setItem("anios_values", anios)         
            localStorage.setItem("colecciones_values", colecc)                       
            setFiltros({tituloBA,'autorBA':autor,palabraClaveBA,ISBNBA,'coleccionBA':colecc,temaBA,'anioPublicacionBA':anios, documentoBA})             
            window.scrollTo(0,600)
        }   
    }
    const asignaValor= (e:any, tipo:number) => {   
        console.table(e);
        switch (tipo) {
            case 0:
                setSelectedColeccion(e)
                //localStorage.setItem('colBA', JSON.stringify(e));
                setResultC(e)
            break;
            case 1:
                if (e){
                    setSelectedTema(e)
                    //localStorage.setItem("temaSeleccionado", JSON.stringify(e))
                    setTemaBA(e.value.toString());
                }else{
                    setTemaBA('');
                    //localStorage.setItem("temaSeleccionado", JSON.stringify({}))
                }   
            break;            
            case 2:
                setSelectedAnio(e)
                //localStorage.setItem('aniosBA', JSON.stringify(e));
                setAnioSeleccionada(e);
            break;           
            case 3:
                console.log(e);
                
                setSelectedAutor(e)
                //localStorage.setItem('autBA', JSON.stringify(e));
                
                setResultAut(e)
            break;
        }          
    }
    const limpiaFiltros=()=>{
        localStorage.setItem('autBA','');
        localStorage.setItem("temaSeleccionado", '');
        localStorage.setItem('aniosBA','');
        localStorage.setItem('colBA', '');
        setResultAut([]);
        setAnioSeleccionada([]);
        setResultC([]);
        setTituloBA('');
        setTemaBA('');
        setISBNBA('');
        setPalabraClaveBA('');
        setDocumentoBA('');
        setSelectedAutor([]);
        setSelectedTema([]);
        setSelectedColeccion([]);
        setSelectedAnio([]);
        localStorage.clear();
        setFiltros({tituloBA:'',autorBA:'',palabraClaveBA:'',ISBNBA:'',coleccionBA:'', temaBA:'', anioPublicacionBA:'', documentoBA:''});
    }

    return(<>

        <div className="container-fluid">
            <div className="row justify-content-left background_busqueda">
                <div className="col-md-8 formulario_avanzado m-md-4 p-sm-5">
                    <form onSubmit={(e) => { e.preventDefault(); generaFiltros()}}>    
                        <div className="form-group row">
                            <label  className="col-form-label col-sm-3 label_busqueda" htmlFor="palabra2">Titulo:</label>
                            <div className="col-sm-9 px-md-0">
                                <input onKeyUp={(e)=>Filtros(e,0)} defaultValue={tituloBA} onChange={e => tituloBA} type="text" id="titulo" name="titulo" className="form-control" maxLength={50}/> 
                            </div>
                        </div>
                        <div className="form-group row mt-2">
                            <label className="col-form-label col-sm-3 label_busqueda">Autor:</label>
                            <div className="col-sm-9 px-md-0">
                                {/* <input onKeyUp={(e)=>Filtros(e,1)} defaultValue={autorBA} onChange={e => autorBA} type="text" id="autor" name="autor" className="form-control" maxLength={50}/> */}
                                <Select
                                    
                                    defaultValue={autorSeleccionado}
                                    value={selectedAutor}
                                    isClearable
                                    isMulti
                                    name="autor"
                                    options={inputAutores}
                                    className="basic-multi-select"
                                    classNamePrefix=""
                                    placeholder=""
                                    onChange={(e)=>asignaValor(e, 3)}
                                />
                            </div>
                        </div>
                        <div className="form-group row mt-2">
                            <label  className="col-form-label col-sm-3 label_busqueda">Colección:</label>
                            <div className="col-sm-9 px-md-0">
                                <Select
                                    defaultValue={coleccionSeleccionada}
                                    value={selectedColeccion}
                                    isClearable
                                    isMulti
                                    name="coleccion"
                                    options={inputColecciones}
                                    className="basic-multi-select"
                                    classNamePrefix=""
                                    placeholder=""
                                    onChange={(e)=>asignaValor(e, 0)}
                                />
                            </div>
                        </div>
                        <div className="form-group row mt-2">
                            <label className="col-form-label col-sm-3 label_busqueda">Tema:</label>
                            <div className="col-sm-9 px-md-0">
                                <Select                                    
                                    defaultValue={temaSeleccionado}
                                    value={selectedTema}
                                    name="tema"

                                    
                                    options={inputTemas}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder=""
                                    onChange={(e)=>asignaValor(e,1)}
                                   
                                />                                
                            </div>
                        </div>                        
                        <div className="form-group row mt-2">
                            <label className="col-form-label col-sm-3 label_busqueda">Año de publicación:</label>
                            <div className="col-sm-9 px-md-0">
                                       <Select
                                            defaultValue={anioSeleccionada}
                                            value={selectedAnio}
                                            isMulti
                                            name="ani"
                                            options={inputAnios}
                                            className="basic-multi-select"
                                            classNamePrefix=""
                                            placeholder=""
                                            onChange={(e)=>asignaValor(e, 2)}
                                        />
                            </div>
                        </div>
                        <div className="form-group row mt-2">
                            <label className="col-form-label col-sm-3 label_busqueda">ISBN:</label>
                            <div className="col-sm-9 px-md-0">
                                <input onKeyUp={(e)=>Filtros(e,3)} defaultValue={ISBNBA} onChange={e => ISBNBA} type="text" id="isbn" name="isbn" className="form-control" maxLength={50}/>
                            </div>
                        </div>
                        <div className="form-group row mt-2">
                            <label className="col-form-label col-sm-3 label_busqueda">Palabra clave:</label>
                            <div className="col-sm-9 px-md-0">
                                <input onKeyUp={(e)=>Filtros(e,4)} defaultValue={palabraClaveBA} onChange={e => palabraClaveBA} type="text" id="palabrac" name="palabrac" className="form-control" maxLength={50}/>
                            </div>
                        </div>
                        <div className="form-group row mt-2">
                            <label className="col-form-label col-sm-3 label_busqueda">Búsqueda en documento:</label>
                            <div className="col-sm-9 px-md-0">
                                <input onKeyUp={(e)=>Filtros(e,5)} defaultValue={documentoBA} onChange={(e) =>documentoBA} type="text" id="docum" name="docum" className="form-control" maxLength={50}/>
                            </div>
                        </div> 
                        <div className="row justify-content-center mt-3 mt-sm-4">
                            <button type="submit" className="col btn_busqueda " >Buscar</button>
                            <input type="reset" className="col btn_busqueda "  value="Limpiar" onClick={limpiaFiltros} />
                        </div>    
                    </form>
                </div>
            </div>
        </div>  
        <AreaResultados filtrosBA={filtros}/>
    </>)
}
